import { Component, input, OnInit } from '@angular/core';
import { Developer } from 'src/app/shared/models/developer.model';
import { CardModule } from 'primeng/card';

import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-developer-card',
  templateUrl: './developer-card.component.html',
  styleUrls: ['./developer-card.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    ButtonDirective
],
})
export class DeveloperCardComponent implements OnInit {
  developer = input.required<Developer>();

  constructor() { }

  ngOnInit(): void { }
}
